import styled from 'styled-components/macro';

import TableBase from '@components/common/core/Utils/Table';

export const ProviderWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ProductCostTable = styled(TableBase)``;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
`;

export const Dot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.green.default};
`;

export const ActionsButton = styled.button`
  padding: 12px;
  border: none;
  background-color: transparent;
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
  margin: 0 auto;
`;

export const ActionsWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ActionButton = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.font};
  cursor: pointer;
  transition: color 0.3s;
  position: relative;

  &:hover {
    color: ${({ theme }) => theme.colors.green.default};
  }

  &:active {
    color: ${({ theme }) => theme.colors.green.dark};
  }

  &:first-child {
    margin-bottom: 12px;
  }
`;

export const AccessibleActionsButtonName = styled.span`
  position: absolute;
  opacity: 0;
  width: 0;
`;
